import { Link } from "@inertiajs/react"
import { Zap } from "lucide-react"

import { Button } from "@/components/ui/button"
import { Progress } from "@/components/ui/progress"

interface UsageMeterProps {
  used: number
  limit: number
  plan: "free" | "plus" | "pro"
}

export function UsageMeter({ used, limit, plan }: UsageMeterProps) {
  const percentage = (used / limit) * 100

  if (percentage < 50) {
    return null
  }

  const isAtLimit = used >= limit
  const showUpgrade = plan !== "pro"

  return (
    <div className="bg-muted/50 mb-6 rounded-lg border p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Zap className="h-4 w-4" />
          <span className="text-sm font-medium">
            {isAtLimit
              ? "Daily limit reached"
              : `${used} of ${limit} operations used today`}
          </span>
        </div>
        {showUpgrade && (
          <Button size="sm" asChild>
            <Link href="/pricing">Upgrade</Link>
          </Button>
        )}
      </div>
      <Progress value={percentage} className="mt-2" />
      {isAtLimit && plan === "pro" && (
        <p className="text-muted-foreground mt-2 text-sm">Resets at midnight</p>
      )}
    </div>
  )
}
